import { apiClient } from "../config/axiosConfig";
import endpoints from "../endpoints/endpoints";

export const authModule = {
  // Register user - returns pending status until email verification
  register: async (userData) => {
    try {
      const response = await apiClient.post(endpoints.signup, userData);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Registration successful. Please verify your email.",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Registration failed",
        error: error.response?.data || error,
      };
    }
  },

  // Verify email with token
  verifyEmail: async (token) => {
    try {
      const response = await apiClient.post(endpoints.verifyEmail, { token });
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Email verified successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Email verification failed",
        error: error.response?.data || error,
      };
    }
  },

  // Verify email with OTP
  verifyEmailOtp: async (payload) => {
    try {
      const response = await apiClient.post(endpoints.verifyEmailOtp, payload);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Email verified successfully with OTP",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Email verification with OTP failed",
        error: error.response?.data || error,
      };
    }
  },

  // Resend verification email
  resendVerification: async (email) => {
    try {
      const response = await apiClient.post(endpoints.resendVerification, { email });
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Verification email sent",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to resend verification email",
        error: error.response?.data || error,
      };
    }
  },

  // Request Password Reset OTP
  requestPasswordResetOtp: async (payload) => {
    try {
      const response = await apiClient.post(
        endpoints.requestPasswordResetOtp,
        payload
      );
      return {
        success: true,
        data: response.data,
        message: response.data.message || "OTP sent successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to send OTP",
        error: error.response?.data || error,
      };
    }
  },

  // Verify Password Reset OTP
  verifyPasswordResetOtp: async (payload) => {
    try {
      const response = await apiClient.post(
        endpoints.verifyPasswordResetOtp,
        payload
      );
      return {
        success: true,
        data: response.data,
        message: response.data.message || "OTP verified successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || error.message || "Invalid OTP",
        error: error.response?.data || error,
      };
    }
  },

  // Reset Password
  resetPassword: async (payload) => {
    try {
      const response = await apiClient.post(endpoints.resetPassword, payload);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Password reset successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to reset password",
        error: error.response?.data || error,
      };
    }
  },

  resetPasswordWithToken: async (uidb64, token, newPassword) => {
    try {
      const url = `${endpoints.resetPasswordWithToken}${uidb64}/${token}/`;
      const response = await apiClient.post(url, { 
        new_password: newPassword 
      });
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Password reset successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to reset password",
        error: error.response?.data || error,
      };
    }
  },
};
